<template>
  <div class="landing-page-senior">
    <link
      href="https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,500;1,400&family=Mulish:wght@300;400;700&display=swap"
      rel="stylesheet"
    />
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

    <!-- Header -->
    <header class="senior-header">
      <div class="logo-container">
        <a href="#">
          <img src="@/assets/images/Ativo 3logo 1.png" alt="Logo Sênior Shopping" class="logo-img" />
        </a>
      </div>
      <nav>
        <a href="#sobre">Sobre</a>
        <a href="#servicos">Serviços</a>
        <a href="#voucher" class="btn-nav">Quero meu voucher</a>
      </nav>
    </header>

    <!-- Hero Section -->
    <section class="senior-parallax-hero">
      <div class="senior-overlay"></div>
      <div class="senior-hero-content">
        <div class="prelaunch-badge">Em breve</div>
        <h1>Cuidado que orienta.<br />Curadoria que acolhe.</h1>
        <p>A plataforma mais segura do Brasil para conectar você a serviços de longevidade.</p>
        <br />
        <a href="#voucher" class="btn-cta">Garantir meu voucher grátis</a>
      </div>
    </section>

    <!-- Intro Section -->
    <section class="senior-intro-section" id="sobre">
      <h2>Simplicidade é o novo luxo.</h2>
      <p>
        Criamos um ambiente onde encontrar ajuda especializada não é um problema, mas uma solução tranquila. Navegue
        com clareza, encontre com segurança e decida com confiança.
      </p>
    </section>

    <!-- Parallax Divider (Segurança) -->
    <section class="senior-parallax-divider">
      <div class="senior-glass-card">
        <div class="senior-security-icon">
          <i class="fa-solid fa-shield-halved"></i>
        </div>
        <h3>Sua segurança é nossa prioridade</h3>
        <p>
          Analisamos criteriosamente antecedentes e qualificações de cada profissional e empresa parceira.
          <br />
          <strong>Aqui, você encontra cuidado com total tranquilidade.</strong>
        </p>
      </div>
    </section>

    <!-- Services Section -->
    <section class="senior-services-section" id="servicos">
      <div class="senior-cards-wrapper">
        <div class="senior-service-card">
          <i class="fa-solid fa-user-nurse senior-icon-box" style="color: #82a097"></i>
          <h3>Saúde & Cuidado</h3>
          <p>Enfermeiros, cuidadores e fisioterapeutas especializados no público sênior.</p>
        </div>
        <div class="senior-service-card">
          <i class="fa-solid fa-couch senior-icon-box" style="color: #cba34b"></i>
          <h3>Conforto em Casa</h3>
          <p>Adaptações, móveis ergonômicos e tecnologia assistiva para o lar.</p>
        </div>
        <div class="senior-service-card">
          <i class="fa-solid fa-plane-departure senior-icon-box" style="color: #4a6faf"></i>
          <h3>Lazer & Social</h3>
          <p>Viagens em grupo, cursos e atividades para manter a mente ativa.</p>
        </div>
      </div>
    </section>

    <!-- Voucher / Lead Capture Section -->
    <section class="prelaunch-capture-section" id="voucher">
      <div class="prelaunch-capture-inner">
        <div class="prelaunch-capture-icon">
          <i class="fa-solid fa-tag"></i>
        </div>
        <h2>Seja um dos primeiros anunciantes</h2>
        <p class="prelaunch-capture-sub">
          Cadastre-se agora e receba um <strong>voucher para anunciar 30 dias grátis</strong>.<br />
          Sem compromisso. Quando o site abrir, seu espaço estará garantido.
        </p>

        <!-- Formulário -->
        <form v-if="!submitted" class="prelaunch-form" @submit.prevent="submitLead">
          <div class="prelaunch-form-fields">
            <div class="prelaunch-field">
              <label for="lead-name">Nome</label>
              <input
                id="lead-name"
                v-model="form.name"
                type="text"
                placeholder="Seu nome completo"
                autocomplete="name"
                required
              />
            </div>
            <div class="prelaunch-field">
              <label for="lead-email">E-mail</label>
              <input
                id="lead-email"
                v-model="form.email"
                type="email"
                placeholder="seu@email.com"
                autocomplete="email"
                required
              />
            </div>
          </div>
          <p v-if="errorMsg" class="prelaunch-error">{{ errorMsg }}</p>
          <button type="submit" class="prelaunch-submit-btn" :disabled="loading">
            <span v-if="loading"><i class="fa-solid fa-spinner fa-spin"></i> Enviando...</span>
            <span v-else>Quero meu voucher grátis</span>
          </button>
        </form>

        <!-- Confirmação -->
        <div v-else class="prelaunch-success">
          <i class="fa-solid fa-circle-check prelaunch-success-icon"></i>
          <h3>Pronto! Verifique seu e-mail.</h3>
          <p>
            Enviamos o seu código de voucher para <strong>{{ form.email }}</strong>.<br />
            Use-o quando o site abrir para anunciar gratuitamente por 30 dias.
          </p>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="senior-footer" id="contato">
      <h2>Vamos começar?</h2>
      <p style="font-size: 1.4rem; max-width: 600px; margin: 0 auto 40px; opacity: 0.9">
        Em breve você poderá anunciar seus serviços para quem procura qualidade no mercado sênior.
      </p>
      <a href="#" class="senior-btn-footer" @click.prevent="openWhatsApp">Fale Conosco</a>
      <div class="senior-footer-links">&copy; 2025 Sênior Shopping Brasil. Todos os direitos reservados.</div>
    </footer>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'PreLaunchPage',
  data() {
    return {
      form: {
        name: '',
        email: '',
      },
      loading: false,
      submitted: false,
      errorMsg: '',
      enterprisePhone: null,
    };
  },
  methods: {
    async submitLead() {
      this.errorMsg = '';
      this.loading = true;
      try {
        await api.post('/lead-capture', {
          name: this.form.name,
          email: this.form.email,
          source: 'landing-page',
        });
        this.submitted = true;
      } catch (error) {
        const msg = error?.response?.data?.error;
        this.errorMsg = msg || 'Ocorreu um erro. Tente novamente.';
      } finally {
        this.loading = false;
      }
    },
    sanitizePhone(phone) {
      if (!phone) return '';
      return String(phone).replace(/\D/g, '');
    },
    async getEnterpriseData() {
      try {
        const response = await api.get('/enterprise/home');
        const enterprise = response.data?.data?.[0] || {};
        this.enterprisePhone = enterprise.phone || null;
      } catch (error) {
        console.error('Erro ao carregar dados da empresa:', error);
      }
    },
    openWhatsApp() {
      if (!this.enterprisePhone) return;
      const phone = this.sanitizePhone(this.enterprisePhone);
      if (!phone) return;
      window.open(`https://wa.me/55${phone}`, '_blank', 'noopener,noreferrer');
    },
  },
  mounted() {
    this.getEnterpriseData();
  },
};
</script>

<style>
/* =========================================================== */
/* PRE-LAUNCH PAGE — herda identidade visual da LandingPage    */
/* =========================================================== */

/* Badge "Em breve" */
.prelaunch-badge {
  display: inline-block !important;
  background: var(--dourado) !important;
  color: var(--azul-inst) !important;
  font-family: 'Mulish', sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 900 !important;
  letter-spacing: 3px !important;
  text-transform: uppercase !important;
  padding: 8px 22px !important;
  border-radius: 999px !important;
  margin-bottom: 28px !important;
}

/* Seção de captura de leads */
.prelaunch-capture-section {
  background: var(--bege-fundo) !important;
  padding: 100px 10% !important;
  text-align: center !important;
}

.prelaunch-capture-inner {
  max-width: 680px !important;
  margin: 0 auto !important;
}

.prelaunch-capture-icon {
  font-size: 48px !important;
  color: var(--dourado) !important;
  margin-bottom: 20px !important;
}

.prelaunch-capture-section h2 {
  font-family: 'Lora', serif !important;
  font-size: 2.8rem !important;
  color: var(--azul-inst) !important;
  margin-bottom: 16px !important;
  line-height: 1.15 !important;
}

.prelaunch-capture-sub {
  font-size: 1.15rem !important;
  line-height: 1.7 !important;
  color: var(--azul-inst) !important;
  opacity: 0.85 !important;
  margin-bottom: 40px !important;
}

/* Formulário */
.prelaunch-form {
  display: flex !important;
  flex-direction: column !important;
  gap: 0 !important;
  align-items: center !important;
}

.prelaunch-form-fields {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 16px !important;
  width: 100% !important;
  margin-bottom: 20px !important;
}

.prelaunch-field {
  display: flex !important;
  flex-direction: column !important;
  text-align: left !important;
}

.prelaunch-field label {
  font-size: 0.85rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px !important;
  color: var(--azul-inst) !important;
  margin-bottom: 6px !important;
  text-transform: uppercase !important;
}

.prelaunch-field input {
  padding: 14px 18px !important;
  font-size: 1rem !important;
  font-family: 'Mulish', sans-serif !important;
  border: 2px solid rgba(22, 60, 83, 0.2) !important;
  border-radius: 8px !important;
  background: #fff !important;
  color: var(--azul-inst) !important;
  outline: none !important;
  transition: border-color 0.25s !important;
  width: 100% !important;
  box-sizing: border-box !important;
}

.prelaunch-field input:focus {
  border-color: var(--dourado) !important;
}

.prelaunch-field input::placeholder {
  color: #9ca3af !important;
}

.prelaunch-error {
  color: #dc2626 !important;
  font-size: 0.9rem !important;
  margin-bottom: 14px !important;
}

.prelaunch-submit-btn {
  display: inline-block !important;
  background-color: var(--azul-inst) !important;
  color: #fff !important;
  padding: 18px 48px !important;
  font-size: 1rem !important;
  font-weight: 900 !important;
  text-transform: uppercase !important;
  letter-spacing: 2px !important;
  border-radius: 50px !important;
  border: none !important;
  cursor: pointer !important;
  transition: 0.3s !important;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;
  font-family: 'Mulish', sans-serif !important;
}

.prelaunch-submit-btn:hover:not(:disabled) {
  background-color: var(--dourado) !important;
  color: var(--azul-inst) !important;
  transform: translateY(-3px) !important;
}

.prelaunch-submit-btn:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}

/* Mensagem de sucesso */
.prelaunch-success {
  background: #fff !important;
  border: 2px solid var(--dourado) !important;
  border-radius: 16px !important;
  padding: 40px 30px !important;
  margin-top: 10px !important;
}

.prelaunch-success-icon {
  font-size: 52px !important;
  color: var(--dourado) !important;
  display: block !important;
  margin-bottom: 16px !important;
}

.prelaunch-success h3 {
  font-family: 'Lora', serif !important;
  font-size: 1.8rem !important;
  color: var(--azul-inst) !important;
  margin-bottom: 12px !important;
}

.prelaunch-success p {
  font-size: 1rem !important;
  line-height: 1.7 !important;
  color: var(--azul-inst) !important;
  opacity: 0.85 !important;
}

/* Responsivo */
@media (max-width: 768px) {
  .prelaunch-capture-section {
    padding: 60px 5% !important;
  }

  .prelaunch-capture-section h2 {
    font-size: 2rem !important;
  }

  .prelaunch-form-fields {
    grid-template-columns: 1fr !important;
  }

  .prelaunch-submit-btn {
    width: 100% !important;
    padding: 18px 0 !important;
  }
}
</style>
